import { createSelector } from 'reselect';

export const searchSelector = (state) => state.search;

export const searchOpenedSelector = createSelector(
  searchSelector,
  (search) => search.searchOpened,
);
